var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightShapeInverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7515 6.48365C30.6002 8.7711 22.0661 9.92501 13.7875 10.9821C12.0044 11.2037 10.349 9.96704 10.2216 8.22472C9.96688 6.48111 11.2413 4.88653 12.897 4.66492C20.9209 3.64728 29.1987 2.55834 36.9679 0.356226C38.6236 -0.121386 40.4074 0.861846 40.9169 2.55323C41.4263 4.24334 40.4072 6.00477 38.7515 6.48365Z",
    fill: "#484EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2697 38.9145C40.1513 52.3016 25.3772 63.9656 12.5135 77.7119C11.3673 78.9957 9.32944 79.0645 8.05581 77.866C6.78218 76.6662 6.65531 74.6488 7.92895 73.365C20.7926 59.5792 35.5668 47.8771 48.6852 34.4504C49.9588 33.1972 51.9961 33.1794 53.2697 34.4122C54.416 35.6438 54.5434 37.6613 53.2697 38.9145Z",
    fill: "#484EA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8513 80.2172C78.2334 72.5551 78.6148 64.8929 78.9968 57.2295C78.9968 55.4744 80.5259 54.1192 82.309 54.2046C84.0921 54.2912 85.365 55.7851 85.365 57.5415C84.9829 65.2164 84.6016 72.89 84.2195 80.5637C84.0921 82.3187 82.5635 83.665 80.7804 83.5694C79.1247 83.4739 77.724 81.971 77.8513 80.2172Z",
    fill: "#484EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightShapeInverse);
export default __webpack_public_path__ + "static/media/highlight_shape_inverse.47370d28d0d383b67e70ebaf8e9bd787.svg";
export { ForwardRef as ReactComponent };